/**
 * Cart Upsell Step — asset: cart-upsell-step.js
 *
 * Flow:
 *  1. User clicks "Checkout Securely" in the cart drawer
 *  2. Intercept checkout intent
 *  3. Open configured upsell UI variant (A or B)
 *  4. Accept  -> add selected variant -> continue checkout
 *     Decline -> continue checkout
 */
(function () {
  'use strict';

  var CONFIG = window.CartUpsellStepConfig;
  if (!CONFIG || !CONFIG.enabled || (!CONFIG.upsell1ProductHandle && !CONFIG.upsell2ProductHandle)) return;

  var productDataByVariant = {
    upsell1: null,
    upsell2: null
  };
  var productRequestByVariant = {
    upsell1: null,
    upsell2: null
  };
  var selectedVariantIdByVariant = {
    upsell1: '',
    upsell2: ''
  };
  var activeUiVariant = 'upsell1';

  var refs = {};
  var hasBoundEvents = false;
  var hideTimer = null;
  var offerTimerInterval = null;
  var scarcityProgressRaf = null;
  var socialProofInterval = null;
  var orderCountInterval = null;
  var ANON_ID_STORAGE_KEY = 'cu-step-ab-anon-id';
  var DEBUG_VARIANT_STORAGE_KEY = 'cu-step-debug-ui-variant';

  var SOCIAL_PROOFS = [
    '<strong>Carlos de Madrid</strong> aprovechó esta oferta hace 2 min',
    '<strong>Javier de Valencia</strong> aprovechó esta oferta hace 4 min',
    '<strong>Diego de Sevilla</strong> aprovechó esta oferta hace 1 min',
    '<strong>Miguel de Bilbao</strong> aprovechó esta oferta hace 6 min',
    '<strong>Antonio de Málaga</strong> aprovechó esta oferta hace 3 min',
    '<strong>Sergio de Zaragoza</strong> aprovechó esta oferta hace 5 min',
    '<strong>David de Murcia</strong> aprovechó esta oferta hace 2 min',
    '<strong>Pablo de Alicante</strong> aprovechó esta oferta hace 7 min',
    '<strong>Raúl de Granada</strong> aprovechó esta oferta hace 3 min',
    '<strong>Iván de Valladolid</strong> aprovechó esta oferta hace 8 min',
    '<strong>Rubén de Córdoba</strong> aprovechó esta oferta hace 4 min',
    '<strong>Adrián de Palma</strong> aprovechó esta oferta hace 2 min',
    '<strong>Óscar de Vigo</strong> aprovechó esta oferta hace 6 min',
    '<strong>Álvaro de Gijón</strong> aprovechó esta oferta hace 5 min',
    '<strong>Hugo de Santander</strong> aprovechó esta oferta hace 3 min',
    '<strong>Mario de León</strong> aprovechó esta oferta hace 7 min',
    '<strong>Lucas de Salamanca</strong> aprovechó esta oferta hace 1 min',
    '<strong>Jorge de Pamplona</strong> aprovechó esta oferta hace 4 min',
    '<strong>Álex de Tarragona</strong> aprovechó esta oferta hace 2 min',
    '<strong>Nacho de Burgos</strong> aprovechó esta oferta hace 5 min',
    '<strong>Pedro de A Coruña</strong> aprovechó esta oferta hace 6 min'
  ];
  var SCARCITY_BASE_PERCENT = 73;

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function normalizeUiVariant(value) {
    var normalized = String(value || '').toLowerCase().trim();
    return normalized === 'upsell2' || normalized === 'b' ? 'upsell2' : 'upsell1';
  }

  function isVariantEnabled(value) {
    var variantName = normalizeUiVariant(value);

    if (variantName === 'upsell2') {
      return !!(CONFIG.upsell2Enabled && CONFIG.upsell2ProductHandle);
    }

    return !!(CONFIG.upsell1Enabled && CONFIG.upsell1ProductHandle);
  }

  function getFallbackUiVariant(value) {
    var variantName = normalizeUiVariant(value);
    return variantName === 'upsell2' ? 'upsell1' : 'upsell2';
  }

  function resolveUsableUiVariant(value) {
    var variantName = normalizeUiVariant(value);
    if (isVariantEnabled(variantName)) return variantName;

    var fallback = getFallbackUiVariant(variantName);
    if (isVariantEnabled(fallback)) return fallback;

    return variantName;
  }

  function getProductHandleForVariant(value) {
    var variantName = normalizeUiVariant(value);
    return variantName === 'upsell2' ? CONFIG.upsell2ProductHandle : CONFIG.upsell1ProductHandle;
  }

  function getProductDataForVariant(value) {
    return productDataByVariant[normalizeUiVariant(value)];
  }

  function getActiveProductData() {
    return getProductDataForVariant(activeUiVariant);
  }

  function getStoredVariantId(value) {
    return selectedVariantIdByVariant[normalizeUiVariant(value)] || '';
  }

  function setStoredVariantId(value, variantId) {
    selectedVariantIdByVariant[normalizeUiVariant(value)] = variantId ? String(variantId) : '';
  }

  function generateAnonId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'anon-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function getAnonId() {
    try {
      var existing = localStorage.getItem(ANON_ID_STORAGE_KEY);
      if (existing) return existing;

      var created = generateAnonId();
      localStorage.setItem(ANON_ID_STORAGE_KEY, created);
      return created;
    } catch (_) {
      return '';
    }
  }

  function simpleHash(str) {
    var input = String(str || '');
    var h = 0;

    for (var i = 0; i < input.length; i += 1) {
      h = ((h << 5) - h) + input.charCodeAt(i);
      h |= 0;
    }

    return h >>> 0;
  }

  function getAssignedUiVariant() {
    var experimentName = asTrimmedText(CONFIG.experimentName) || 'cart-upsell-step-ui-v1';
    var anonId = getAnonId();
    if (!anonId) {
      return resolveUsableUiVariant(CONFIG.uiVariant || 'upsell1');
    }

    var bucket = simpleHash(experimentName + ':' + anonId) % 100;
    return resolveUsableUiVariant(bucket < 50 ? 'upsell1' : 'upsell2');
  }

  function readUiVariantFromUrl() {
    try {
      var raw = new URLSearchParams(window.location.search).get('cu_step_variant');
      if (!raw) return '';
      return normalizeUiVariant(String(raw).toLowerCase());
    } catch (_) {
      return '';
    }
  }

  function readDebugUiVariantFromStorage() {
    try {
      var raw = localStorage.getItem(DEBUG_VARIANT_STORAGE_KEY);
      if (!raw) return '';
      return normalizeUiVariant(String(raw).toLowerCase());
    } catch (_) {
      return '';
    }
  }

  function getPreferredUiVariant() {
    var fromUrl = readUiVariantFromUrl();
    if (fromUrl) return resolveUsableUiVariant(fromUrl);

    if (shouldShowDevToggle()) {
      var fromStorage = readDebugUiVariantFromStorage();
      if (fromStorage) return resolveUsableUiVariant(fromStorage);
    }

    return getAssignedUiVariant();
  }

  function persistDebugUiVariant(value) {
    try {
      localStorage.setItem(DEBUG_VARIANT_STORAGE_KEY, normalizeUiVariant(value));
    } catch (_) {}
  }

  function shouldShowDevToggle() {
    return !!CONFIG.debugSwitcherEnabled;
  }

  function refreshDevToggleUi() {
    var toggle = $('#cu-step-dev-toggle');
    if (!toggle) return;

    toggle.hidden = !shouldShowDevToggle();

    var buttons = toggle.querySelectorAll('[data-cu-variant-choice]');
    buttons.forEach(function (btn) {
      var v = normalizeUiVariant(btn.getAttribute('data-cu-variant-choice') || 'upsell1');
      btn.disabled = !isVariantEnabled(v);
      btn.classList.toggle('is-active', v === activeUiVariant);
    });
  }

  function getMoneyFormat() {
    var configured = asTrimmedText(CONFIG.moneyFormat);
    return configured || '${{amount}}';
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var decimals = precision == null ? 2 : precision;
    var thousandsSeparator = thousands == null ? ',' : thousands;
    var decimalSeparator = decimal == null ? '.' : decimal;
    var value = Number(number || 0);

    if (!Number.isFinite(value)) value = 0;

    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    var cents = parts[1] ? decimalSeparator + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents) {
    if (cents == null || cents === '') return '';

    var centsValue = Number(cents);
    if (!Number.isFinite(centsValue)) return '';

    var format = getMoneyFormat();
    var formatString = /\{\{\s*(\w+)\s*\}\}/;
    var placeholderMatch = format.match(formatString);
    var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
    var amount = '';

    switch (placeholder) {
      case 'amount':
        amount = formatWithDelimiters(centsValue / 100, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        amount = formatWithDelimiters(centsValue / 100, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = formatWithDelimiters(centsValue / 100, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = formatWithDelimiters(centsValue / 100, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = formatWithDelimiters(centsValue / 100, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        amount = formatWithDelimiters(centsValue / 100, 0, ' ', '.');
        break;
      case 'amount_with_space_separator':
        amount = formatWithDelimiters(centsValue / 100, 2, ' ', '.');
        break;
      default:
        amount = formatWithDelimiters(centsValue / 100, 2, ',', '.');
    }

    return format.replace(formatString, amount);
  }

  function asTrimmedText(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getSessionKey() {
    return (CONFIG && CONFIG.sessionKey) ? CONFIG.sessionKey : 'cu-step-shown-v2';
  }

  function markUpsellHandledForSession() {
    if (!CONFIG || !CONFIG.oncePerSession) return;
    try {
      sessionStorage.setItem(getSessionKey(), '1');
    } catch (_) {}
  }

  function formatTimerValue(totalSeconds) {
    var safe = Math.max(0, totalSeconds | 0);
    var mins = Math.floor(safe / 60);
    var secs = safe % 60;
    return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
  }

  function stopOfferTimer() {
    if (offerTimerInterval) {
      clearInterval(offerTimerInterval);
      offerTimerInterval = null;
    }
  }

  function startOfferTimer() {
    stopOfferTimer();
    if (!refs.timerEl) return;

    var total = parseInt(CONFIG.timerSeconds, 10);
    if (!total || total < 0) {
      refs.timerEl.textContent = '00:00';
      setScarcityProgress(0, 0);
      return;
    }

    var remaining = total;
    refs.timerEl.textContent = formatTimerValue(remaining);
    startScarcityProgressAnimation(remaining, total);

    offerTimerInterval = setInterval(function () {
      remaining -= 1;
      if (remaining <= 0) {
        refs.timerEl.textContent = '00:00';
        setScarcityProgress(0, total);
        stopOfferTimer();
        return;
      }
      refs.timerEl.textContent = formatTimerValue(remaining);
    }, 1000);
  }

  function stopSocialProofTicker() {
    if (socialProofInterval) {
      clearInterval(socialProofInterval);
      socialProofInterval = null;
    }
  }

  function startSocialProofTicker() {
    stopSocialProofTicker();
    if (!refs.socialProofEl) return;

    var idx = 0;
    refs.socialProofEl.innerHTML = SOCIAL_PROOFS[0];

    socialProofInterval = setInterval(function () {
      idx = (idx + 1) % SOCIAL_PROOFS.length;
      refs.socialProofEl.style.opacity = '0';
      setTimeout(function () {
        if (!refs.socialProofEl) return;
        refs.socialProofEl.innerHTML = SOCIAL_PROOFS[idx];
        refs.socialProofEl.style.opacity = '1';
      }, 250);
    }, 4000);
  }

  function stopOrderCountTicker() {
    if (orderCountInterval) {
      clearInterval(orderCountInterval);
      orderCountInterval = null;
    }
  }

  function getEstDecimalHour() {
    var now = new Date();
    var utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    var est = new Date(utcMs - 5 * 3600000);
    return est.getHours() + est.getMinutes() / 60 + est.getSeconds() / 3600;
  }

  function calcOrders() {
    var h = getEstDecimalHour();
    var dailyMax = 1487;
    var progress = 0;

    if (h < 6) progress = 0.01 + (h / 6) * 0.04;
    else if (h < 12) progress = 0.05 + ((h - 6) / 6) * 0.32;
    else if (h < 18) progress = 0.37 + ((h - 12) / 6) * 0.44;
    else if (h < 22) progress = 0.81 + ((h - 18) / 4) * 0.16;
    else progress = 0.97 + ((h - 22) / 2) * 0.03;

    var now = new Date();
    var minuteOfDay = now.getUTCHours() * 60 + now.getUTCMinutes();
    var jitter = (minuteOfDay % 11) * 1.1;

    return Math.min(dailyMax, Math.round(dailyMax * progress + jitter));
  }

  function updateOrderCount() {
    if (!refs.orderCountEl) return;
    refs.orderCountEl.textContent = calcOrders().toLocaleString();
  }

  function startOrderCountTicker() {
    stopOrderCountTicker();
    if (!refs.orderCountEl) return;
    updateOrderCount();
    orderCountInterval = setInterval(updateOrderCount, 60000);
  }

  function stopVariantEnhancements() {
    stopOfferTimer();
    stopScarcityProgressAnimation();
    stopSocialProofTicker();
    stopOrderCountTicker();
  }

  function setScarcityProgress(remaining, total) {
    var barEl = refs.scarcityBarFill || $('#cu-step-v2 .cu2-bar-fill');
    if (!barEl) return;

    var progress = 100;
    if (Number.isFinite(total) && total > 0) {
      var safeRemaining = Math.max(0, Number(remaining) || 0);
      progress = SCARCITY_BASE_PERCENT + (((total - safeRemaining) / total) * (100 - SCARCITY_BASE_PERCENT));
    } else {
      progress = SCARCITY_BASE_PERCENT;
    }
    progress = Math.max(0, Math.min(100, progress));
    barEl.style.transition = 'none';
    barEl.style.width = progress.toFixed(2) + '%';
  }

  function stopScarcityProgressAnimation() {
    if (scarcityProgressRaf) {
      cancelAnimationFrame(scarcityProgressRaf);
      scarcityProgressRaf = null;
    }
  }

  function startScarcityProgressAnimation(remaining, total) {
    stopScarcityProgressAnimation();
    var barEl = refs.scarcityBarFill || $('#cu-step-v2 .cu2-bar-fill');
    if (!barEl) return;
    if (!Number.isFinite(total) || total <= 0) {
      setScarcityProgress(0, 0);
      return;
    }

    var safeRemaining = Math.max(0, Number(remaining) || 0);
    var startProgress = SCARCITY_BASE_PERCENT + (((total - safeRemaining) / total) * (100 - SCARCITY_BASE_PERCENT));
    startProgress = Math.max(0, Math.min(100, startProgress));

    barEl.style.transition = 'none';
    barEl.style.width = startProgress.toFixed(2) + '%';
    if (safeRemaining <= 0) return;

    var durationMs = safeRemaining * 1000;
    var startedAt = performance.now();

    function step(now) {
      if (!barEl) return;

      var elapsed = Math.max(0, now - startedAt);
      var ratio = Math.min(1, elapsed / durationMs);
      var nextProgress = startProgress + (100 - startProgress) * ratio;
      barEl.style.width = nextProgress.toFixed(2) + '%';

      if (ratio >= 1) {
        scarcityProgressRaf = null;
        return;
      }

      scarcityProgressRaf = requestAnimationFrame(step);
    }

    scarcityProgressRaf = requestAnimationFrame(step);
  }

  function startVariantEnhancements() {
    startOfferTimer();
    if (activeUiVariant === 'upsell2') {
      startSocialProofTicker();
      startOrderCountTicker();
    } else {
      stopSocialProofTicker();
      stopOrderCountTicker();
    }
  }

  function resolveRefs() {
    refs = {
      root: $('#cu-step-root'),
      step: activeUiVariant === 'upsell2' ? $('#cu-step-v2') : $('#cu-step'),
      imgEl: activeUiVariant === 'upsell2' ? $('#cu2-img') : $('#cu-img'),
      titleEl: activeUiVariant === 'upsell2' ? $('#cu2-title') : $('#cu-title'),
      ratingEl: activeUiVariant === 'upsell2' ? $('#cu2-rating-text') : $('#cu-rating-text'),
      priceRowEl: activeUiVariant === 'upsell2' ? null : $('#cu-price-row'),
      priceOrigLabel: activeUiVariant === 'upsell2' ? null : $('#cu-price-orig-label'),
      priceCurrentLabel: activeUiVariant === 'upsell2' ? null : $('#cu-price-current-label'),
      priceOrigEl: activeUiVariant === 'upsell2' ? $('#cu2-price-orig') : $('#cu-price-orig'),
      priceCurEl: activeUiVariant === 'upsell2' ? $('#cu2-price-cur') : $('#cu-price-cur'),
      saveAmountEl: activeUiVariant === 'upsell2' ? $('#cu2-save-amount') : null,
      variantWrap: activeUiVariant === 'upsell2' ? $('#cu2-variant-wrap') : $('#cu-variant-wrap'),
      variantLabel: activeUiVariant === 'upsell2' ? $('#cu2-variant-label') : $('#cu-variant-label'),
      variantSelect: activeUiVariant === 'upsell2' ? $('#cu2-variant-select') : $('#cu-variant-select'),
      variantButtonsWrap: activeUiVariant === 'upsell2' ? $('#cu2-variant-buttons') : null,
      acceptBtn: activeUiVariant === 'upsell2' ? $('#cu2-accept-btn') : $('#cu-accept-btn'),
      declineBtn: activeUiVariant === 'upsell2' ? $('#cu2-decline-btn') : $('#cu-decline-btn'),
      closeBtn: activeUiVariant === 'upsell2' ? $('#cu2-close-btn') : $('#cu-close-btn'),
      timerEl: activeUiVariant === 'upsell2' ? $('#cu2-timer') : $('#cu-timer'),
      orderCountEl: activeUiVariant === 'upsell2' ? $('#cu2-order-count') : null,
      socialProofEl: activeUiVariant === 'upsell2' ? $('#cu2-social-proof') : null,
      scarcityBarFill: activeUiVariant === 'upsell2' ? $('.cu2-bar-fill') : null
    };
  }

  function setActiveUiVariant(nextVariant) {
    var resolved = resolveUsableUiVariant(nextVariant);

    var wasOpen = !!(refs.root && refs.root.classList.contains('cu-root-visible'));

    activeUiVariant = resolved;

    var root = $('#cu-step-root');
    if (root) {
      root.setAttribute('data-cu-variant', resolved);
    }

    var upsell1Panel = $('#cu-step');
    var upsell2Panel = $('#cu-step-v2');

    if (upsell1Panel) {
      upsell1Panel.classList.toggle('cu-step-panel-active', resolved === 'upsell1');
      upsell1Panel.classList.remove('cu-visible');
    }

    if (upsell2Panel) {
      upsell2Panel.classList.toggle('cu-step-panel-active', resolved === 'upsell2');
      upsell2Panel.classList.remove('cu-visible');
    }

    stopVariantEnhancements();
    resolveRefs();
    refreshDevToggleUi();

    var activeProduct = getActiveProductData();
    if (activeProduct) {
      populatePanel(activeProduct, resolved);
    } else {
      preloadVariantProduct(resolved);
    }

    var selectedVariantId = getStoredVariantId(resolved);
    if (selectedVariantId) {
      applyVariantState(selectedVariantId, resolved);
    }

    if (wasOpen && refs.step) {
      refs.step.classList.add('cu-visible');
      startVariantEnhancements();
    }
  }

  function getConfiguredTitleText(productTitle, uiVariant) {
    var resolved = normalizeUiVariant(uiVariant);
    var upsell1TitleText = asTrimmedText(CONFIG.upsell1TitleText) || asTrimmedText(CONFIG.titleOverride) || productTitle;
    var upsell2TitleText = asTrimmedText(CONFIG.upsell2TitleText) || upsell1TitleText || productTitle;
    return resolved === 'upsell2' ? upsell2TitleText : upsell1TitleText;
  }

  function updateTitleText(productTitle, uiVariant) {
    if (!refs.titleEl) return;
    refs.titleEl.textContent = getConfiguredTitleText(productTitle, uiVariant);
  }

  function updateRatingText(uiVariant) {
    if (!refs.ratingEl) return;

    var upsell1Text = asTrimmedText(CONFIG.upsell1RatingText) || asTrimmedText(CONFIG.ratingText);
    var upsell2Text = asTrimmedText(CONFIG.upsell2RatingText) || upsell1Text;
    var text = normalizeUiVariant(uiVariant) === 'upsell2' ? upsell2Text : upsell1Text;
    if (text) refs.ratingEl.textContent = text;
  }

  function updateVariantLabels(product, uiVariant) {
    if (!refs.variantLabel) return;

    var fallbackLabel = (product && product.options && product.options[0] && product.options[0].name) ? product.options[0].name : '';
    var upsell1LabelText = asTrimmedText(CONFIG.upsell1VariantLabel) || fallbackLabel;
    var upsell2LabelText = asTrimmedText(CONFIG.upsell2VariantLabel) || fallbackLabel;
    refs.variantLabel.textContent = normalizeUiVariant(uiVariant) === 'upsell2' ? upsell2LabelText : upsell1LabelText;
  }

  function updateImageForVariant(variant, uiVariant) {
    var product = getProductDataForVariant(uiVariant);
    var variantImage = variant && variant.featured_image && variant.featured_image.src ? variant.featured_image.src : null;
    var fallback = product && product.images && product.images[0] ? product.images[0] : '';
    var newSrc = variantImage || fallback;
    var imgEl = refs.imgEl;
    if (!imgEl || !newSrc) return;
    if (imgEl.src === newSrc && imgEl.alt === (product && product.title ? product.title : '')) return;

    imgEl.style.opacity = '0';
    imgEl.src = newSrc;
    imgEl.alt = product && product.title ? product.title : '';

    var fadeIn = function () {
      imgEl.style.opacity = '1';
    };

    if (imgEl.complete) {
      requestAnimationFrame(fadeIn);
    } else {
      imgEl.onload = fadeIn;
    }
  }

  function getVariantMoneyMap(uiVariant) {
    var resolved = normalizeUiVariant(uiVariant || activeUiVariant);
    if (resolved === 'upsell2') return CONFIG.upsell2VariantMoneyMap || {};
    return CONFIG.upsell1VariantMoneyMap || {};
  }

  function getFormattedVariantMoney(variant, key, uiVariant) {
    if (!variant || !key) return '';
    var variantMoneyMap = getVariantMoneyMap(uiVariant);
    if (!variantMoneyMap) return '';

    var entry = variantMoneyMap[String(variant.id)];
    if (!entry || typeof entry !== 'object') return '';

    return asTrimmedText(entry[key]);
  }

  function containsHtml(value) {
    return /<[^>]+>/.test(String(value || ''));
  }

  function setNodeContent(node, value) {
    if (!node) return;

    var content = value == null ? '' : String(value);
    if (containsHtml(content)) {
      node.innerHTML = content;
    } else {
      node.textContent = content;
    }
  }

  function refreshConvertedMoney() {
    if (!window.bucksCC || typeof window.bucksCC.reConvert !== 'function') return;

    try {
      window.bucksCC.reConvert();
    } catch (_) {}
  }

  function renderUpsell1PriceLine(currentPriceText, originalPriceText, hasOriginalPrice) {
    if (!refs.priceRowEl) return;

    var beforeOriginal = asTrimmedText(CONFIG.upsell1PriceBeforeOriginalText);
    var beforeDiscount = hasOriginalPrice
      ? String(CONFIG.upsell1PriceBeforeDiscountText || '')
      : String(CONFIG.upsell1PriceBeforeDiscountNoCompareText || '');
    var afterDiscount = String(CONFIG.upsell1PriceAfterDiscountText || '');
    var markup = '';

    if (hasOriginalPrice) {
      markup += '<span id="cu-price-orig-label" class="cu-price-copy cu-price-copy--orig">' + escapeHtml(beforeOriginal) + '</span>';
      markup += '<span id="cu-price-orig" class="cu-price-original">' + escapeHtml(originalPriceText) + '</span>';
    }

    if (beforeDiscount) {
      markup += '<span id="cu-price-current-label" class="cu-price-copy cu-price-copy--current">' + escapeHtml(beforeDiscount) + '</span>';
    }

    markup += '<span id="cu-price-cur" class="cu-price-current">' + escapeHtml(currentPriceText) + '</span>';

    if (afterDiscount) {
      markup += '<span id="cu-price-suffix" class="cu-price-copy cu-price-copy--suffix">' + escapeHtml(afterDiscount) + '</span>';
    }

    refs.priceRowEl.innerHTML = markup;
    refs.priceOrigLabel = $('#cu-price-orig-label', refs.priceRowEl);
    refs.priceCurrentLabel = $('#cu-price-current-label', refs.priceRowEl);
    refs.priceOrigEl = $('#cu-price-orig', refs.priceRowEl);
    refs.priceCurEl = $('#cu-price-cur', refs.priceRowEl);
  }

  function updatePriceRowForVariant(variant) {
    if (!variant) return;

    var basePriceText = getFormattedVariantMoney(variant, 'price') || formatMoney(variant.price);

    var upsell2InlinePrice = activeUiVariant === 'upsell2' ? $('#cu2-price-inline') : null;
    if (upsell2InlinePrice) {
      setNodeContent(upsell2InlinePrice, basePriceText);
    }

    var configuredOriginalPrice = asTrimmedText(CONFIG.originalPrice);
    var hasOriginalPrice = false;
    var originalPriceText = '';

    if (configuredOriginalPrice) {
      hasOriginalPrice = true;
      originalPriceText = configuredOriginalPrice;
    } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      hasOriginalPrice = true;
      originalPriceText = getFormattedVariantMoney(variant, 'compareAt') || formatMoney(variant.compare_at_price);
    }

    if (activeUiVariant !== 'upsell2') {
      renderUpsell1PriceLine(basePriceText, originalPriceText, hasOriginalPrice);
      refreshConvertedMoney();
      return;
    }

    if (refs.priceCurEl) {
      setNodeContent(refs.priceCurEl, basePriceText);
    }

    if (refs.priceOrigEl) {
      if (hasOriginalPrice) {
        setNodeContent(refs.priceOrigEl, originalPriceText);
        refs.priceOrigEl.style.display = '';
      } else {
        refs.priceOrigEl.style.display = 'none';
      }
    }

    if (refs.priceOrigLabel) {
      refs.priceOrigLabel.style.display = hasOriginalPrice ? '' : 'none';
    }

    var saveText = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var formattedSaveAmount = getFormattedVariantMoney(variant, 'save') || formatMoney(variant.compare_at_price - variant.price);
      saveText = 'Ahorras ' + formattedSaveAmount;
    }

    if (refs.saveAmountEl) {
      setNodeContent(refs.saveAmountEl, saveText);
      refs.saveAmountEl.style.display = saveText ? '' : 'none';
    }

    var saveBadge = activeUiVariant === 'upsell2' ? $('#cu2-save-badge') : null;
    if (saveBadge) {
      if (saveText) {
        setNodeContent(saveBadge, saveText.replace('Ahorras ', 'Ahorra '));
        saveBadge.style.display = '';
      } else {
        saveBadge.style.display = 'none';
      }
    }

    refreshConvertedMoney();
  }

  function getVariantById(variantId, uiVariant) {
    var product = getProductDataForVariant(uiVariant || activeUiVariant);
    if (!product || !product.variants || !variantId) return null;
    var wanted = String(variantId);

    for (var i = 0; i < product.variants.length; i += 1) {
      if (String(product.variants[i].id) === wanted) return product.variants[i];
    }

    return null;
  }

  function syncVariantControls(variant) {
    if (!variant) return;

    var wantedId = String(variant.id);

    if (refs.variantSelect) {
      refs.variantSelect.value = wantedId;
    }

    if (refs.variantButtonsWrap) {
      var buttons = refs.variantButtonsWrap.querySelectorAll('[data-cu-variant-id]');
      buttons.forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-cu-variant-id') === wantedId);
      });
    }

    if (refs.acceptBtn && !refs.acceptBtn.classList.contains('cu-loading')) {
      refs.acceptBtn.disabled = !variant.available;
    }
  }

  function applyVariantState(variantId, uiVariant) {
    var resolved = normalizeUiVariant(uiVariant || activeUiVariant);
    var variant = getVariantById(variantId, resolved);
    if (!variant) return;

    setStoredVariantId(resolved, variant.id);

    if (resolved !== activeUiVariant) {
      return;
    }

    updatePriceRowForVariant(variant);
    updateImageForVariant(variant, resolved);
    syncVariantControls(variant);
  }

  function buildVariantControls(product, uiVariant) {
    if (!product || normalizeUiVariant(uiVariant) !== activeUiVariant) return;

    var variants = product && product.variants ? product.variants : [];
    if (!variants.length) return;

    var firstAvailableId = '';

    if (refs.variantSelect) {
      refs.variantSelect.innerHTML = '';
      variants.forEach(function (variant) {
        var opt = document.createElement('option');
        opt.value = String(variant.id);
        opt.textContent = variant.title;
        opt.disabled = !variant.available;
        refs.variantSelect.appendChild(opt);

        if (!firstAvailableId && variant.available) {
          firstAvailableId = String(variant.id);
        }
      });
    }

    if (refs.variantButtonsWrap) {
      refs.variantButtonsWrap.innerHTML = '';
      variants.forEach(function (variant) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cu2-v-btn';
        btn.textContent = variant.title;
        btn.setAttribute('data-cu-variant-id', String(variant.id));
        btn.disabled = !variant.available;
        btn.addEventListener('click', function () {
          applyVariantState(String(variant.id), uiVariant);
        });
        refs.variantButtonsWrap.appendChild(btn);
      });
    }

    var hasMultiple = variants.length > 1;
    if (activeUiVariant === 'upsell1' && refs.variantWrap) {
      refs.variantWrap.style.display = hasMultiple ? '' : 'none';
    }
    if (activeUiVariant === 'upsell2' && refs.variantWrap) {
      refs.variantWrap.classList.toggle('cu2-hidden', !hasMultiple);
    }

    updateVariantLabels(product, uiVariant);

    if (!firstAvailableId) {
      firstAvailableId = String(variants[0].id);
    }

    var preferredVariantId = getStoredVariantId(uiVariant);
    if (!getVariantById(preferredVariantId, uiVariant)) {
      preferredVariantId = firstAvailableId;
    }

    applyVariantState(preferredVariantId, uiVariant);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);

    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function preloadProductImages(product) {
    if (!product || !product.variants) return;

    product.variants.forEach(function (variant) {
      var imgSrc = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : null;
      if (!imgSrc) return;
      var preload = new Image();
      preload.src = imgSrc;
    });
  }

  function preloadVariantProduct(uiVariant) {
    var resolved = normalizeUiVariant(uiVariant);
    var handle = getProductHandleForVariant(resolved);
    if (!handle) return Promise.resolve(null);

    if (productDataByVariant[resolved]) {
      return Promise.resolve(productDataByVariant[resolved]);
    }

    if (productRequestByVariant[resolved]) {
      return productRequestByVariant[resolved];
    }

    productRequestByVariant[resolved] = fetchProduct(handle)
      .then(function (data) {
        productDataByVariant[resolved] = data;
        preloadProductImages(data);

        if (data && resolved === activeUiVariant) {
          populatePanel(data, resolved);
        }

        productRequestByVariant[resolved] = null;
        return data;
      })
      .catch(function () {
        productRequestByVariant[resolved] = null;
        return null;
      });

    return productRequestByVariant[resolved];
  }

  function populatePanel(product, uiVariant) {
    if (!product) return;
    if (normalizeUiVariant(uiVariant) !== activeUiVariant) return;

    updateTitleText(product.title, uiVariant);
    updateRatingText(uiVariant);

    if (refs.imgEl && product.images && product.images[0]) {
      refs.imgEl.src = product.images[0];
      refs.imgEl.alt = product.title;
    }

    buildVariantControls(product, uiVariant);
  }

  function addVariantToCart(variantId) {
    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { Accept: 'application/javascript' }
    };

    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');

    var drawer = $('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      formData.append('sections', drawer.getSectionsToRender().map(function (section) { return section.id; }));
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;

    var cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    return fetch(cartAddUrl, config)
      .then(function (r) {
        return r.json().catch(function () { return null; });
      })
      .then(function (payload) {
        if (!payload) throw new Error('Unable to add selected variant');
        if (payload.status) throw new Error(payload.description || 'Unable to add selected variant');
        return payload;
      })
      .then(function (payload) {
        if (drawer && payload.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(payload);
          return payload;
        }
        return refreshCartDrawerUI().then(function () { return payload; });
      })
      .catch(function (err) {
        return refreshCartDrawerUI()
          .then(function () { throw err; })
          .catch(function () { throw err; });
      });
  }

  function setAcceptLoading(isLoading) {
    ['upsell1', 'upsell2'].forEach(function (uiVariant) {
      var btn = $(uiVariant === 'upsell2' ? '#cu2-accept-btn' : '#cu-accept-btn');
      if (!btn) return;

      if (isLoading) {
        btn.disabled = true;
        btn.classList.add('cu-loading');
        return;
      }

      btn.classList.remove('cu-loading');

      var current = getVariantById(getStoredVariantId(uiVariant), uiVariant);
      btn.disabled = !!(current && !current.available);
    });
  }

  function showPanel() {
    setActiveUiVariant(getPreferredUiVariant());

    if (!refs.root || !refs.step) return false;

    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    setAcceptLoading(false);

    refs.root.classList.add('cu-root-visible');
    document.body.classList.add('cu-step-open');

    requestAnimationFrame(function () {
      if (refs.step) refs.step.classList.add('cu-visible');
      startVariantEnhancements();
    });

    return true;
  }

  function hidePanel(callback) {
    if (!refs.root) {
      stopVariantEnhancements();
      if (callback) callback();
      return;
    }

    var upsell1Panel = $('#cu-step');
    var upsell2Panel = $('#cu-step-v2');
    var isVisible = !!((upsell1Panel && upsell1Panel.classList.contains('cu-visible')) || (upsell2Panel && upsell2Panel.classList.contains('cu-visible')));

    if (!isVisible) {
      refs.root.classList.remove('cu-root-visible');
      document.body.classList.remove('cu-step-open');
      stopVariantEnhancements();
      if (callback) callback();
      return;
    }

    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    if (upsell1Panel) upsell1Panel.classList.remove('cu-visible');
    if (upsell2Panel) upsell2Panel.classList.remove('cu-visible');

    stopVariantEnhancements();

    hideTimer = setTimeout(function () {
      refs.root.classList.remove('cu-root-visible');
      document.body.classList.remove('cu-step-open');
      hideTimer = null;
      if (callback) callback();
    }, 340);
  }

  function refreshCartDrawerUI() {
    var drawer = $('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      return Promise.resolve();
    }

    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    var sectionsUrl = cartUrl + '?sections=cart-drawer,cart-icon-bubble';

    return fetch(sectionsUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer'] || !sections['cart-icon-bubble']) return;
        drawer.renderContents({
          id: Date.now(),
          sections: sections
        });
      })
      .catch(function () {});
  }

  function resolveCheckoutTargets() {
    var ctx = window.__cuStepCheckoutContext || {};
    var cartForm = null;
    var checkoutBtn = null;

    if (ctx.formId) {
      cartForm = document.getElementById(ctx.formId);
    }

    if (!cartForm) {
      cartForm = $('#CartDrawer-Form') || $('#cart');
    }

    if (ctx.submitterId) {
      checkoutBtn = document.getElementById(ctx.submitterId);
    }

    if (!checkoutBtn && cartForm && ctx.submitterName) {
      checkoutBtn = cartForm.querySelector('[name="' + ctx.submitterName + '"]');
    }

    if (!checkoutBtn) {
      checkoutBtn = $('#CartDrawer-Checkout') || $('#checkout') || (cartForm && cartForm.querySelector('[name="checkout"]'));
    }

    return {
      cartForm: cartForm,
      checkoutBtn: checkoutBtn
    };
  }

  function proceedToCheckout() {
    var targets = resolveCheckoutTargets();
    var cartForm = targets.cartForm;
    var checkoutBtn = targets.checkoutBtn;

    window.__cuStepBypass = true;
    setTimeout(function () { window.__cuStepBypass = false; }, 3000);

    if (checkoutBtn && !cartForm && checkoutBtn.form) {
      cartForm = checkoutBtn.form;
    }

    if (!cartForm) {
      window.location.assign('/checkout');
      return;
    }

    if (typeof cartForm.requestSubmit === 'function') {
      if (checkoutBtn && checkoutBtn.form === cartForm) {
        cartForm.requestSubmit(checkoutBtn);
      } else {
        cartForm.requestSubmit();
      }
    } else {
      cartForm.submit();
    }

    window.__cuStepCheckoutContext = null;
  }

  function getSelectedVariantId() {
    var storedId = getStoredVariantId(activeUiVariant);
    if (storedId) return storedId;

    if (refs.variantSelect && refs.variantSelect.value) {
      return String(refs.variantSelect.value);
    }

    var product = getActiveProductData();
    if (product && product.variants && product.variants[0]) {
      return String(product.variants[0].id);
    }

    return '';
  }

  function handleAccept() {
    var variantId = getSelectedVariantId();

    if (!variantId) {
      markUpsellHandledForSession();
      hidePanel(function () {
        proceedToCheckout();
      });
      return;
    }

    setAcceptLoading(true);

    addVariantToCart(variantId)
      .then(function () {
        markUpsellHandledForSession();
        hidePanel(function () {
          proceedToCheckout();
        });
      })
      .catch(function (err) {
        if (err) {
          console.error('[Upsell Step] add-to-cart failed:', err.message || err);
        }
        setAcceptLoading(false);
      });
  }

  function handleDecline() {
    markUpsellHandledForSession();
    hidePanel(function () {
      proceedToCheckout();
    });
  }

  function handleClose() {
    markUpsellHandledForSession();
    hidePanel(function () {
      proceedToCheckout();
    });
  }

  function handleEscape(e) {
    if (e.key !== 'Escape') return;

    var upsell1Visible = $('#cu-step') && $('#cu-step').classList.contains('cu-visible');
    var upsell2Visible = $('#cu-step-v2') && $('#cu-step-v2').classList.contains('cu-visible');
    if (!upsell1Visible && !upsell2Visible) return;

    handleClose();
  }

  function bindEvents() {
    if (hasBoundEvents) return;
    hasBoundEvents = true;

    ['#cu-accept-btn', '#cu2-accept-btn'].forEach(function (sel) {
      var btn = $(sel);
      if (btn) btn.addEventListener('click', handleAccept);
    });

    ['#cu-decline-btn', '#cu2-decline-btn'].forEach(function (sel) {
      var btn = $(sel);
      if (btn) btn.addEventListener('click', handleDecline);
    });

    ['#cu-close-btn', '#cu2-close-btn'].forEach(function (sel) {
      var btn = $(sel);
      if (btn) btn.addEventListener('click', handleClose);
    });

    ['#cu-variant-select', '#cu2-variant-select'].forEach(function (sel) {
      var selectEl = $(sel);
      if (!selectEl) return;
      selectEl.addEventListener('change', function () {
        var uiVariant = sel === '#cu2-variant-select' ? 'upsell2' : 'upsell1';
        applyVariantState(selectEl.value, uiVariant);
      });
    });

    var toggle = $('#cu-step-dev-toggle');
    if (toggle) {
      toggle.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-cu-variant-choice]');
        if (!btn) return;

        var chosen = normalizeUiVariant(btn.getAttribute('data-cu-variant-choice') || 'upsell1');
        if (!isVariantEnabled(chosen)) return;
        persistDebugUiVariant(chosen);
        setActiveUiVariant(chosen);
      });
    }

    document.addEventListener('keydown', handleEscape);
  }

  window.cuStepShow = function () {
    if (!showPanel()) {
      proceedToCheckout();
    }
  };

  function init() {
    setActiveUiVariant(getPreferredUiVariant());

    if (!refs.root || !refs.step) return;

    if (isVariantEnabled('upsell1')) {
      preloadVariantProduct('upsell1');
    }

    if (isVariantEnabled('upsell2')) {
      preloadVariantProduct('upsell2');
    }

    bindEvents();

    if (window.__cuStepPendingOpen) {
      window.__cuStepPendingOpen = false;
      window.cuStepShow();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
